import React, { useEffect, useState } from 'react';
import { getCourses } from '../http/academyAPI';
import { useNavigate } from 'react-router-dom';
import {
  CircularProgress,
  CardContent,
  Typography,
  CardMedia,
  Container,
  Card,
  Grid,
} from '@mui/material';

const Academy = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await getCourses();
        setCourses(data);
      } catch {
        setError('Ошибка при загрузке курсов');
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU');
  };

  if (loading) return <CircularProgress />;
  if (error) return <Typography color='error'>{error}</Typography>;

  return (
    <Container maxWidth='lg' sx={{ padding: 4 }}>
      <Typography variant='h5' component='h1' gutterBottom sx={{ paddingBottom: '40px' }}>
        Обучающие материалы
      </Typography>
      <Grid container spacing={4}>
        {courses.map((course) => (
          <Grid item xs={12} sm={6} md={4} key={course.id}>
            <Card
              sx={{ borderRadius: '15px', cursor: 'pointer' }}
              onClick={() => navigate(`/academy/course/${course.id}`)}
            >
              <CardMedia
                component='img'
                height='200'
                image={course.imageUrl || '/images/course.png'}
                alt={course.name}
              />
              <CardContent>
                <Typography variant='h6' component='h2'>
                  {course.name}
                </Typography>
                <Typography color='textSecondary' sx={{ fontSize: '12px' }}>
                  Курс обновлен: {formatDate(course.updatedAt)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Academy;
